<!-- 字符颜色 -->
<template>
  <BaseFormItem2
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getALUFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: '黑色'
    },
    // 阻焊颜色
    color: {
      type: String,
      default: '正白'
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getALUFields('charcolor')
    },
    options() {
      const { fields, color, val } = this
      let options = fields.options

      const disabledOptions = ['正白', '暖白'].includes(color) ? '白色' : color

      // 如果当前项被禁用
      if (val == disabledOptions) {
        this.changeVal(disabledOptions == '黑色' ? '白色' : '黑色')
      }
      
      return options.map(item => ({...item, disabled: item.value === disabledOptions }))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    color(newVal, oldVal) {
      const whiteOptions = ['正白', '暖白']
      // 阻焊颜色由 【正白】、【暖白】 切换到别的颜色 时 字符颜色切换到 【白色】
      if (whiteOptions.includes(oldVal) && !whiteOptions.includes(newVal)) {
        this.changeVal('白色', true)
      }
    }
  },
  methods: {
    handleEmit() {
      const { val, value } = this
      this.$emit('input', val)
      if (val != value) {
        this.$emit('change', val)
      }
    },
    changeVal(val, notTip = false) {
      if (this.initPcbParamsChange) return
      if (!notTip) {
        this.$topWarning.mergeFields(this.fields.label)
      }
      this.val = val
      this.handleEmit()
    },
  }
}
</script>

<style lang="scss" scoped>
</style>